import { Typography, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  statCard: {
    padding: "16px",
    flex: "1",
    minWidth: "180px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
}));

const AdminDashboardCard = ({ label, value, color, index }) => {
  const classes = useStyles();

  return (
    <Paper
      className={classes.statCard}
      style={{ backgroundColor: color }}
      elevation={3}
      key={index}
    >
      <Typography variant="h4" component="div">
        {value}
      </Typography>
      <Typography variant="body2" component="div">
        {label}
      </Typography>
    </Paper>
  );
};

export default AdminDashboardCard;
